import React, { useEffect, useState } from 'react';
import { AlertTriangle, Clock } from 'lucide-react';
export function AnnouncementBar() {
  // 2 hours, 47 minutes, 0 seconds
  const [timeLeft, setTimeLeft] = useState(2 * 3600 + 47 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <div className="bg-brand-red text-white py-3 px-4 sticky top-0 z-50 shadow-lg" data-id="element-16">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-sm md:text-base font-medium text-center" data-id="element-17">
        <div className="flex items-center gap-2" data-id="element-18">
          <div className="relative flex h-3 w-3 flex-shrink-0" data-id="element-19">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" data-id="element-20"></span>
            <span className="relative inline-flex rounded-full h-3 w-3 bg-white" data-id="element-21"></span>
          </div>
          <AlertTriangle className="w-4 h-4 text-white flex-shrink-0 hidden sm:block" data-id="element-22" />
          <span className="font-black uppercase tracking-wide" data-id="element-23">
            50% OFF por lanzamiento
          </span>
        </div>

        <div className="hidden sm:block text-white/50" data-id="element-24">|</div>

        <div className="flex items-center gap-2 bg-black/20 px-3 py-1 rounded-full" data-id="element-25">
          <Clock className="w-4 h-4" data-id="element-26" />
          <span className="font-mono font-bold tracking-wider" data-id="element-27">
            {String(hours).padStart(2, '0')}:{String(minutes).padStart(2, '0')}:
            {String(seconds).padStart(2, '0')}
          </span>
        </div>
      </div>
    </div>;
}